var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('button', {
    staticClass: "customizer-header-buy-button customizer-header-buy-button-label text-center",
    attrs: {
      "aria-label": _vm.translations.headerBuy
    },
    on: {
      "click": _vm.handleBuyButtonClick
    }
  }, [!_vm.showShareInStore ? _c('currency-wrapper', {
    staticClass: "customizer-header-buy-button-label-span",
    attrs: {
      "priceRaw": _vm.$store.state.buyPanel.price.string
    }
  }, [_vm._v("\n    " + _vm._s(_vm.translations.headerBuy) + "\n  ")]) : _c('span', {
    staticClass: "customizer-header-buy-button-label-span"
  }, [_vm._v("\n    " + _vm._s(_vm.translations.shareInStoreHeader) + "\n  ")])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }